import CloseIcon from "@mui/icons-material/Close";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Grid,
  IconButton,
  Modal,
  TextField,
  Typography
} from "@mui/material";
import { LocalizationProvider, MobileDatePicker, MobileTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { debounce } from "lodash";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { BILightGrey } from "../../assets/helpers";
import Loader from "../../common/Loader";
import {
  FETCH_CLIENT_JOBS,
  FETCH_CLIENT_TIMESHEET_UD_FIELDS_NEW,
  SAVE_CLIENT_SAFETY_INCIDENT,
  SAVE_CLIENT_UD_FIELDS_VALUES
} from "../../constant/Apipath";
import { Getrequestcall } from "../../request/Getrequest";
import { Postrequestcall } from "../../request/Postrequest";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";
import moment from "moment/moment";
import { ClientUDFieldComponent } from "../safety-observation/ClientUDFieldComponent";

function AddClientSafetyIncident({ open, handleClose }) {
  const { loginData, multiLanguageData, selectedClientData } = useSelector((state) => state?.main);

  const {
    TEXT_DATE,
    TEXT_TIME,
    TEXT_JOB,
    TEXT_SEAECH_FOR_JOB,
    TEXT_DESCRIPTION,
    TEXT_HAPPENED_IMMEDIATE_ACTION,
    BTN_SUBMIT,
    CLIENT_NOTIFIELD
  } = ClientEnglishFallback.ClientSaftyIncidentAddModal(
    multiLanguageData?.ClientSaftyIncidentAddModal || {}
  );

  const [jobData, setJobData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [udFieldData, setUdFieldData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTermFlag, setSearchTermFlag] = useState(false);
  const [clientSafetyIncident, setClientSafetyIncident] = useState({
    date: dayjs(),
    time: dayjs(),
    job: {
      id: 0,
      label: "",
      fullLabel: ""
    },
    description: "",
    searchTerm: ""
  });
  const [clientUdFieldChecks, setClientUdFieldChecks] = useState({});

  const [picketOpen, setPickerOpen] = useState(false);

  useEffect(() => {
    const debouncedGetInitialData = debounce(getInitialData, 500);
    debouncedGetInitialData();
    return () => {
      debouncedGetInitialData.cancel();
    };
  }, [searchTerm]);

  const getInitialData = async () => {
    await getClientJob();
    setIsLoading(false);
  };

  const getClientJob = async () => {
    try {
      let obj = {
        PageNr: 1,
        NrOfRecPerPage: 20,
        FullSearch: searchTermFlag ? "" : searchTerm,
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [{ ClientId: selectedClientData?.ClientId, active: true }]
      };

      const clientJobResponse = await Postrequestcall(
        FETCH_CLIENT_JOBS,
        obj,
        loginData?.accessToken
      );
      if (clientJobResponse?.status === 200) {
        const datas = clientJobResponse?.data?.data;
        const updatedData = datas?.map((data) => {
          return {
            id: data.id,
            label: data.name,
            fullLabel: data.jobCode + " - " + data.name
          };
        });
        setJobData(updatedData);
      } else {
        console.log("getClientJob-> Error Getting Client Job");
      }
    } catch (error) {
      console.log("getClientJob-> Error Getting Client Job: ", error);
    }
  };

  const getClientUdFieldData = async (jobId) => {
    try {
      let payload = {
        ClientId: selectedClientData?.ClientId,
        JobList: jobId ? jobId.toString() : "",
        EmployeeId: "",
        ActivityId: ""
      };
      const udFieldResponse = await Postrequestcall(
        FETCH_CLIENT_TIMESHEET_UD_FIELDS_NEW,
        payload,
        loginData?.accessToken
      );
      if (udFieldResponse?.status === 200) {
        const rawData = udFieldResponse?.data?.data;
        let fields = [];
        if (Array.isArray(rawData)) {
          fields = rawData;
        } else if (rawData && typeof rawData === "object") {
          fields = [
            ...(rawData.jobUdFields || []),
            ...(rawData.employeeUdFields || []),
            ...(rawData.activityUdFields || [])
          ];
        }
        const filteredFields = jobId
          ? fields.filter((field) => field.entityRecordId === 0 || field.entityRecordId === jobId)
          : fields;
        setUdFieldData(filteredFields);
        const initialCheckboxState = {};
        const initialTextState = {};
        filteredFields.forEach((ele) => {
          if (ele.udFieldTypeId === 1 || ele.udFieldTypeName === "Checkbox") {
            initialCheckboxState[ele.id] = ele.fieldDefaultValue === "true" || ele.fieldDefaultValue === true;
          } else {
            initialTextState[ele.id] = ele.fieldDefaultValue || "";
          }
        });
        setClientUdFieldChecks({ ...initialCheckboxState, ...initialTextState });
      } else {
        setUdFieldData([]);
        setClientUdFieldChecks({});
      }
    } catch (error) {
      console.log("getClientUdFieldData-> Error Getting Client UD Fields: ", error);
    }
  };

  const handleUDFieldChange = (id, value, type) => {
    setClientUdFieldChecks((prev) => ({
      ...prev,
      [id]: value,
    }));
    setUdFieldData((prev) => 
      prev.map(field => field.id === id ? { ...field, value: value } : field)
    );
  };

  const handleInputChange = (value, field) => {
    setClientSafetyIncident((prevState) => ({
      ...prevState,
      [field]: value
    }));
    if (field === "job") {
      getClientUdFieldData(value?.id);
    }
  };

  const shouldDisable = () => {
    return (
      clientSafetyIncident.date !== null &&
      clientSafetyIncident.time !== null &&
      clientSafetyIncident.job.id !== 0 &&
      clientSafetyIncident.description !== ""
    );
  };

  const getDateFormatWithYears = (isoString) => {
    return moment(isoString).format("YYYY-MM-DD");
  };

  const getTimeFormatWithHours = (isoString) => {
    return moment(isoString).format("HH:mm:ss");
  };

  const SaveClientIncidentData = async () => {
    try {
      setIsLoading(true);

      let isUdField = false;
      udFieldData.forEach((field) => {
        const value = clientUdFieldChecks[field.id];
        if (value !== undefined) {
          isUdField = true;
        }
      });

      const obj = {
        ReturnRecordId: 1,
        ReturnRecordError: 1,
        UserId: loginData?.userInformation?.UserId,
        SaveList: [
          {
            Id: 0,
            ClientEmployeeId: selectedClientData?.ClientEmployeeId,
            IncidentDate: clientSafetyIncident.date
              ? getDateFormatWithYears(clientSafetyIncident.date)
              : "",
            IncidentTime: clientSafetyIncident.time
              ? getTimeFormatWithHours(new Date(clientSafetyIncident.time))
              : "",
            ClientJobId: clientSafetyIncident.job.id,
            Description: clientSafetyIncident.description,
            udFields: "",
            ModifiedBy: loginData?.userInformation?.UserId,
            isUDField: isUdField
          }
        ]
      };

      const isRecordSaved = await Postrequestcall(
        SAVE_CLIENT_SAFETY_INCIDENT,
        obj,
        loginData?.accessToken
      );
      if (isRecordSaved?.status === 201) {
        const savedId = isRecordSaved?.data?.data?.[0]?.objData?.id || isRecordSaved?.data?.data?.[0]?.id || isRecordSaved?.data?.data?.id || isRecordSaved?.data?.data;
        
        if (isUdField && savedId) {
          let saveList = [];
          udFieldData.forEach((field) => {
            const value = clientUdFieldChecks[field.id];
            if (value !== undefined) {
              let valStr = "";
              if (typeof value === "boolean") {
                valStr = value ? "true" : "false";
              } else {
                valStr = value.toString();
              }
              if (valStr.trim() !== "") {
                saveList.push({
                  Id: 0,
                  ClientId: selectedClientData?.ClientId,
                  ClientEmployeeId: selectedClientData?.ClientEmployeeId,
                  AppId: 2,
                  AppRecordId: savedId,
                  AppEntityId: field.appEntityId,
                  EntityRecordId: field.entityRecordId,
                  UDFieldId: field.id,
                  Value: valStr,
                  ModifiedBy: loginData?.userInformation?.UserId
                });
              }
            }
          });

          if (saveList.length > 0) {
            const udFieldObj = {
              ReturnRecordId: 1,
              ReturnRecordError: 1,
              UserId: loginData?.userInformation?.UserId,
              SaveList: saveList
            };
            await Postrequestcall(
              SAVE_CLIENT_UD_FIELDS_VALUES,
              udFieldObj,
              loginData?.accessToken
            );
          }
        }

        setIsLoading(false);
        handleClose(true);
      } else {
        console.log("SaveClientIncidentData-> Error Saving Client Incident Data");
      }
    } catch (error) {
      setIsLoading(false);
      console.log("SaveClientIncidentData-> Error Saving Client Incident Data: ", error);
    }
    setIsLoading(false);
  };

  return (
    <div>
      <Modal open={open} onClose={handleClose}>
        <div style={{ outline: "none" }}>
          {isLoading ? (
            <Loader fullScreen />
          ) : (
            <Box sx={{ marginTop: 2 }} borderRadius={2} className="client-modal-responsive">
              <Grid container spacing={1}>
                <Grid size={12}>
                  <IconButton
                    sx={{
                      display: "flex",
                      justifySelf: "flex-end",
                      color:
                        selectedClientData?.AccentColor !== undefined &&
                        selectedClientData?.AccentColor
                          ? selectedClientData?.AccentColor
                          : BILightGrey
                    }}
                    onClick={handleClose}>
                    <CloseIcon />
                  </IconButton>
                </Grid>

                <Grid size={{ xs: 12, sm: 7 }}>
                  <Typography variant="body1">{TEXT_DATE}</Typography>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    {/* Custom display field */}
                    <Box
                      onClick={() => setPickerOpen(true)}
                      sx={{
                        height: "40px",
                        backgroundColor: "#e4e4e4",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "0 10px",
                        cursor: "pointer"
                      }}
                      className="ticket-picker add-support" // Keep your existing class
                    >
                      <span>
                        {clientSafetyIncident.date &&
                        dayjs.isDayjs(dayjs(clientSafetyIncident.date))
                          ? dayjs(clientSafetyIncident.date).isSame(dayjs(), "day")
                            ? `${dayjs(clientSafetyIncident.date).format("MMMM DD YYYY")} (Today)`
                            : dayjs(clientSafetyIncident.date).format("MMMM DD YYYY")
                          : dayjs().format("MMMM DD YYYY")}
                      </span>
                      <InsertInvitationIcon
                        sx={{
                          color: selectedClientData?.AccentColor,
                          cursor: "pointer"
                        }}
                      />
                    </Box>

                    {/* Hidden DatePicker for functionality */}
                    <MobileDatePicker
                      open={picketOpen}
                      onOpen={() => setPickerOpen(true)}
                      onClose={() => setPickerOpen(false)}
                      disablePast
                      format="MMMM DD YYYY"
                      value={dayjs(clientSafetyIncident.date)}
                      onChange={(newDate) => {
                        handleInputChange(newDate, "date");
                        setPickerOpen(false); // Close picker after selection
                      }}
                      sx={{ display: "none" }} // Hide the actual picker input
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid size={{ xs: 12, sm: 5 }}>
                  <Typography variant="body1">{TEXT_TIME}</Typography>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <MobileTimePicker
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          size: "small",
                          readOnly: true
                        }
                      }}
                      sx={{
                        "& fieldset": { border: "none" }
                      }}
                      value={dayjs(clientSafetyIncident.time)}
                      onChange={(newDate) => {
                        handleInputChange(newDate, "time");
                      }}
                      className="ticket-picker add-support"
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid size={12}>
                  <Typography variant="body1">{TEXT_JOB}</Typography>
                  <Autocomplete
                    value={jobData.find((job) => job.id === clientSafetyIncident.job.id) || null}
                    onInputChange={(event, value) => {
                      if (event && event.type === "change" && typeof value === "string") {
                        let inputValue = value.replace(/^[^A-Za-z0-9]+/, "");
                        setSearchTerm(inputValue);
                        setSearchTermFlag(false);
                      }
                    }}
                    id="Roles"
                    size="small"
                    options={jobData}
                    onChange={(e, selectedJob) => {
                      if (selectedJob) {
                        handleInputChange(selectedJob, "job");
                      } else {
                        handleInputChange({ id: 0, label: "", fullLabel: "" }, "job");
                      }
                    }}
                    style={{ backgroundColor: "#e4e4e4", borderRadius: "10px" }}
                    sx={{ "& fieldset": { border: "none" } }}
                    getOptionLabel={(option) => `${option?.fullLabel || ""}`}
                    renderInput={(params) => {
                      return (
                        <TextField
                          {...params}
                          variant="outlined"
                          placeholder={TEXT_SEAECH_FOR_JOB}
                        />
                      );
                    }}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                  />
                </Grid>
                <Grid size={12}>
                  <Typography variant="body1">{TEXT_DESCRIPTION}</Typography>
                  <TextField
                    size="small"
                    variant="outlined"
                    required
                    fullWidth
                    onChange={(e) => {
                      let inputValue = e.target.value;
                      inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
                      handleInputChange(inputValue, "description");
                    }}
                    value={clientSafetyIncident.description}
                    minRows={4}
                    slotProps={{
                      input: {
                        rows: 4,
                        multiline: true,
                        inputComponent: "textarea"
                      }
                    }}
                    placeholder={TEXT_HAPPENED_IMMEDIATE_ACTION}
                    className="add-support"
                    sx={{
                      "& fieldset": { border: "none" }
                    }}
                  />
                </Grid>
                <Grid size={12} sx={{ width: "100%" }}>
                  <ClientUDFieldComponent
                    mode="edit"
                    udFields={udFieldData}
                    onChange={handleUDFieldChange}
                  />
                </Grid>
                <Grid size={12} sx={{ marginTop: 1,  overflowX: "auto", display: "flex" }} >
                  <Button
                    disabled={!shouldDisable() || isLoading}
                    variant="contained"
                    fullWidth
                    onClick={SaveClientIncidentData}
                    sx={{
                      backgroundColor: selectedClientData?.AccentColor,
                      textTransform: "none"
                    }}>
                    {BTN_SUBMIT}
                  </Button>
                </Grid>
                {/* {udFieldData?.udFieldTypeName === "Checkbox" && (
                  <Grid
                    size={12}
                    sx={{ marginTop: 1,  display: "flex", alignItems: "center" }}
                    
                    onClick={() => handleInputChange(!clientSafetyIncident.checked, "checked")}>
                    <Checkbox
                      sx={{
                        "&.Mui-checked": {
                          color: selectedClientData?.AccentColor // Sets the checked state color
                        }
                      }}
                      checked={clientSafetyIncident.checked}
                    />{" "}
                    {udFieldData?.fieldLabel}
                  </Grid>
                )} */}
              </Grid>
            </Box>
          )}
        </div>
      </Modal>
    </div>
  );
}

export default AddClientSafetyIncident;
